import { render } from "./XIconSolidActivity.vue?vue&type=template&id=0081cc20"
import script from "./XIconSolidActivity.vue?vue&type=script&lang=js"
export * from "./XIconSolidActivity.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidActivity.vue"]])

export default __exports__